import { IconProps } from '../icons/types';
import styles from './IconButton.module.css';

export const IconButton = (props: IconButtonProps) => {
  return (
    <div className={styles.container} onClick={props.onClick}>
      <props.icon fill="#333" className={styles.icon} />
      {props.label ? <span className={styles.label}>{props.label}</span> : null}
    </div>
  );
};

export interface IconButtonProps {
  icon: React.FC<IconProps>;
  label?: string;
  onClick?: () => void;
}
